<template>
  <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
    <v-toolbar elevation="0">
      <v-text-field
        flat
        solo
        clearable
        prepend-icon="search"
        placeholder="Type something"
        v-model="opsitabletrx.search"
        hide-details
        class=""
      ></v-text-field>
      <v-checkbox
          @change="changeautorefresh"
          v-model="autorefresh"
          label="Auto Refresh"
          color="primary"
          hide-details
      ></v-checkbox>
      <v-spacer></v-spacer>
      <div class="mt-6">
        <v-autocomplete
            clearable
            v-model="opsitabletrx.sellerid"
            :items="mysupplier"
            label="Penjual"
            item-text="sellername"
            item-value="sellerid"
            dense>
          <template slot='selection' slot-scope='{ item }'>
            <div class="ma-0">{{ potongnama(item.sellername) }}</div>
          </template>
          <template slot='item' slot-scope='{ item }'>
            {{ potongnama(item.sellername) }}
          </template>
        </v-autocomplete>
<!--        <v-select-->
<!--            class="mr-2"-->
<!--            clearable-->
<!--            label="Penjual"-->
<!--            hide-details-->
<!--            item-text="sellername"-->
<!--            item-value="sellerid"-->
<!--            v-model="opsitabletrx.sellerid"-->
<!--            :items="mysupplier">-->
<!--          <template slot='selection' slot-scope='{ item }'>-->
<!--            <div class="ma-0">{{ potongnama(item.sellername) }}</div>-->
<!--          </template>-->
<!--          <template slot='item' slot-scope='{ item }'>-->
<!--            {{ potongnama(item.sellername) }}-->
<!--          </template>-->
<!--        </v-select>-->
      </div>
      <div class="mt-6">
        <v-select
          clearable
          label="Status Transaksi"
          item-text="label"
          item-value="id"
          v-model="opsitabletrx.statustrx"
          :items="trxstatuses"
        ></v-select>
      </div>
      <div class="mt-6">
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="opsitabletrx.awal"
              label="Tanggal Awal"
              prepend-icon="event"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="opsitabletrx.awal" @input="menu1 = false"></v-date-picker>
        </v-menu>
      </div>
      <div class="mt-6">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="opsitabletrx.akhir"
              label="Tanggal Akhir"
              prepend-icon="event"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="opsitabletrx.akhir" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </div>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getTrxBuy(opsitabletrx)">
        <v-icon dark>refresh</v-icon>Refresh
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      dense
      sort-by="id"
      :sort-desc="sortdes"
      :headers="headers"
      :search="search"
      :items="trxpembelian"
      class="elevation-0"
      item-key="id"
      :options.sync="opsitabletrx"
      :server-items-length="totaltrxpembelian"
      :loading="loading"
      @update:options="getTrxBuy(opsitabletrx)">
      <template v-slot:item.transactionrc="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
            :color="colorStatus(item.transactionrc)"
            small
            text-color="white">
            {{ trxstatusText(item.transactionrc) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.sellprice="{ item }">
        <div  class="text-right">
          {{formatAngka(item.sellprice)}}
        </div>
      </template>
      <template v-slot:item.productcode="{ item }">
          {{toupper(item.productcode)}}
      </template>
      <template v-slot:item.createat="{ item }">
        {{formatDate(item.createat)}}
      </template>
      <template v-slot:item.updateat="{ item }">
        {{formatDate(item.updateat)}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Utils from '@/plugins/utils'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import S from 'string'

export default {
  name: 'TrxPembelian',
  data: () => ({
    search: '',
    tab: '',
    autorefresh: false,
    intervaltrxautorefresh: '',
    menu1: false,
    menu2: false,
    sortdes: [true],
    dateawal: moment().add(7, 'hours').toISOString().substr(0, 10),
    dateakhir: moment().add(7, 'hours').toISOString().substr(0, 10),
    opsitabletrx: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      statustrx: '',
      sellerid: '',
      sortBy: ['id'],
      awal: moment().add(7, 'hours').toISOString().substr(0, 10),
      akhir: moment().add(7, 'hours').toISOString().substr(0, 10)
    },
    trxstatuses: [
      {
        id: 0,
        label: 'Pending'
      },
      {
        id: 1,
        label: 'Sukses'
      },
      {
        id: 2,
        label: 'Gagal'
      }
    ],
    headers: [
      {
        text: 'TrxId',
        value: 'id'
      },
      {
        text: 'Waktu',
        value: 'createat'
      },
      {
        text: 'Client Ref',
        value: 'reffclient'
      },
      {
        text: 'Kode',
        value: 'productcode'
      },
      {
        text: 'Produk',
        value: 'productname'
      },
      {
        text: 'Tujuan',
        value: 'target'
      },
      {
        text: 'Harga',
        value: 'sellprice'
      },
      {
        text: 'Penjual',
        value: 'sellername'
      },
      {
        text: 'Status',
        value: 'transactionrc'
      },
      {
        text: 'SerialNumber',
        value: 'serialnumber'
      },
      {
        text: 'Keterangan',
        value: 'description'
      },
      {
        text: 'Update',
        value: 'updateat'
      }
    ]
  }),
  beforeDestroy () {
    console.log('Before destroy')
    clearInterval(this.intervaltrxautorefresh)
  },
  mounted () {
    this.getMySupplier()
  },
  computed: {
    ...mapState('TrxPembelian', ['dialog', 'loading', 'overlay', 'trxpembelian', 'totaltrxpembelian']),
    ...mapState('ProductMapping', ['mysupplier'])
  },
  methods: {
    ...mapActions('TrxPembelian', ['setloading', 'setdialog', 'getTrxBuy']),
    ...mapActions('ProductMapping', ['getMySupplier']),
    changeautorefresh () {
      console.log(this.autorefresh)
      if (this.autorefresh) {
        const self = this
        this.intervaltrxautorefresh = setInterval(function () {
          self.getTrxBuy(self.opsitabletrx)
        }, 15000)
      } else {
        clearInterval(this.intervaltrxautorefresh)
      }
    },
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    potongnama (val) {
      if (val.length > 20) {
        return S(val).left(20).replaceAll('`', '').s
      } else {
        return val.toUpperCase()
      }
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    colorStatus (val) {
      if (val === 0) {
        return 'blue'
      }
      if (val === 1) {
        return 'green'
      }
      if (val === 2) {
        return 'red'
      }
    },
    toupper (val) {
      return val.toUpperCase()
    },
    trxstatusText (val) {
      if (val === 0) {
        return 'PENDING'
      }
      if (val === 1) {
        return 'SUKSES'
      }
      if (val === 2) {
        return 'GAGAL'
      }
    }
  }
}
</script>

<style scoped>

</style>
